/* eslint-disable @typescript-eslint/no-inferrable-types */

const strPad = ( str: number|string ) => {
  return `${str}`.padStart(2, '0');
};

export const parsePrice = (price: string = '' ) => {
  const str = Array.from(`${price}`.replace(/[^0-9]/g, ''));
  const beforeComma = parseInt(str.slice(0, -2).join('') || '0', 10);
  const afterComma = strPad(str.slice(-2).join(''));

  return `${beforeComma},${afterComma}`;
}
